import { ConstSearch } from '../constants';

export const filterCheckedList = (
  status: 'area' | 'condition' | 'detail',
  list: string[]
) => {
  switch (status) {
    case 'area':
      return list
        .filter((item) => {
          return item.match(/^area/) === null;
        })
        .filter((item) => {
          return item.match(/^[0-9]/) !== null;
        });
    case 'condition':
      return list
        .filter((item) => {
          return item.match(/^area/) === null;
        })
        .filter((item) => {
          return item.match(/^[0-9]/) === null;
        });
    case 'detail':
      return list
        .filter((item) => {
          return item.match(/^area/) === null;
        })
        .filter((item) => {
          return item.match(/^[0-9]/) === null;
        })
        .filter((item) => {
          return !ConstSearch.equipment.some((e) => e.value === item);
        })
        .filter((item) => {
          return !ConstSearch.location.some((e) => e.value === item);
        })
        .filter((item) => {
          return !ConstSearch.carStock.some((e) => e.value === item);
        })
        .filter((item) => {
          return !ConstSearch.bath.some((e) => e.value === item);
        })
        .filter((item) => {
          return !ConstSearch.businessPeriod.some((e) => e.value === item);
        })
        .filter((item) => {
          return !ConstSearch.checkIn.some((e) => e.value === item);
        });
    default:
      return list;
  }
};
